import React from 'react'
import styles from './style.module.scss'

export const TabFilters = ({momentumsByCategory, onClick}) => {
  if ( !momentumsByCategory ) return <></>

  return (
    <div className={styles.tab}>
      <button
        className={styles.item}
        data-active="true"
        type="button"
        onClick={onClick}
        name="All"
      > 
        Todos ({momentumsByCategory.All.length})
      </button>

      <button
        className={styles.item}
        data-active="false"
        type="button"
        onClick={onClick}
        name="Active"
      >
        Ativos ({momentumsByCategory.Active.length})
      </button>
      <button
        className={styles.item}
        data-active="false"
        type="button"
        onClick={onClick}
        name="Scheduled"
      >
        Agendados ({momentumsByCategory.Scheduled.length})
      </button>

      <button
        className={styles.item}
        data-active="false"
        type="button"
        onClick={onClick}
        name="Paused"
      >
        Pausados ({momentumsByCategory.Paused.length})
      </button>
      <button
        className={styles.item}
        data-active="false"
        type="button"
        onClick={onClick}
        name="Draft"
      >
        Rascunhos ({momentumsByCategory.Draft.length})
      </button>

      <button
        className={styles.item}
        data-active="false"
        type="button"
        onClick={onClick}
        name="Deleted"
      >
        Concluídos ({momentumsByCategory.Deleted.length})
      </button>
    </div>
  )
}